import axios from 'axios';
import { DateTime } from 'luxon';

const USApiKey = 'dZ6a6rRGozDELh2eNirGb9iwJAPk0dMW';

export default class InternationalShowtimesAPI {
  _instance;

  constructor() {
    this.axiosInstanceInternal = null;
    this.baseURL = 'https://api.internationalshowtimes.com/v4/';
  }

  static get instance() {
    if (!this._instance) {
      this._instance = new InternationalShowtimesAPI();
    }
    return this._instance;
  }

  static reset() {
    InternationalShowtimesAPI.instance.axiosInstanceInternal = null;
  }

  get axiosInstance() {
    if (this.axiosInstanceInternal === null) {
      this.axiosInstanceInternal = axios.create({
        baseURL: this.baseURL,
      });
    }
    return this.axiosInstanceInternal;
  }

  async searchCities(name, cancelTokenSource = null) {
    return {
      cities: [
        ...(
          await this.axiosInstance.get('cities', {
            params: { query: name, apikey: USApiKey },
            cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
          })
        ).data.cities,
      ],
    };
  }

  async getCinemas(cityID, cancelTokenSource = null) {
    const usResponse = await this.axiosInstance.get('cinemas', {
      params: { city_ids: `${cityID}`, apikey: USApiKey },
      cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
    });
    return usResponse.data;
  }

  async getShowtimes(id, cityID, cancelTokenSource = null) {
    const usResponse = await this.axiosInstance.get('showtimes', {
      params: {
        movie_id: `${id}`,
        city_ids: `${cityID}`,
        apikey: USApiKey,
      },
      cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
    });
    return usResponse.data;
  }

  async getMovieByTmdbID(tmdbID, cancelTokenSource = null) {
    const successResponse = await this.axiosInstance.get('movies', {
      params: {
        tmdb_id: `${tmdbID}`,
        apikey: USApiKey,
      },
      cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
    });
    return successResponse.data;
  }

  async getMovie(id, cancelTokenSource = null) {
    const successResponse = await this.axiosInstance.get(`movies/${id}?apikey=${USApiKey}`, {
      params: { apikey: USApiKey },
      cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
    });
    return successResponse.data;
  }

  async searchMovies(name, cancelTokenSource = null) {
    const successResponse = await this.axiosInstance.get('movies', {
      params: {
        lang: 'en',
        // release_date_from: showOnlyUpcomingMovies ? DateTime.local().toISODate() : undefined,
        // countries: 'US',
        search_field: 'title',
        search_query: name,
        apikey: USApiKey,
      },
      cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
    });
    return successResponse.data;
  }

  async searchMoviesByGenres(genres, cancelTokenSource = null) {
    const apiParamsSerializer = (params) => {
      const parts = [];
      Object.keys(params).forEach((key) => {
        if (params[key] != null) {
          const obj = params[key];
          if (obj instanceof Array) {
            for (let idx = 0; idx < obj.length; idx += 1) {
              parts.push(`${key}=${encodeURIComponent(obj[idx])}`);
            }
          } else {
            parts.push(`${key}=${encodeURIComponent(obj)}`);
          }
        }
      });
      return parts.join('&');
    };

    const successResponse = await this.axiosInstance.get('movies', {
      params: {
        lang: 'en',
        release_date_from: DateTime.local().minus({ years: 1 }).toISODate(),
        countries: 'US',
        search_field: 'genre',
        search_query: genres,
        fields: 'id,slug,title,tmdb_id,poster_image_thumbnail',
        apikey: USApiKey,
      },
      paramsSerializer: apiParamsSerializer,
      cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
    });
    return successResponse.data;
  }
}
